import { Type } from "class-transformer";
import AssetSubclass from "./assetSubclass";

export default class AssetType {
  /** Asset subclass to which this asset type belongs to.. */
  @Type(() => AssetSubclass)
  assetSubclass: AssetSubclass
  /**
   * @param id GUID of this asset type.
   * @param name 
   * @param description 
   * @param fixProtocolId FIX Protocol ID of this asset type, as defined on fixtrading community dictionary for default values.
   * @param assetSubclass Asset subclass to which this asset type belongs to..
   */
  constructor(
    public id: string | undefined,
    public name: string,
    public description: string,
    public fixProtocolId: string,
    assetSubclass: AssetSubclass
  ) {
    this.assetSubclass = assetSubclass;
  }
}